import {ui} from '@stores'
import { CentricColors, CentricCssVars } from 'centric-ui-components';
import { createTheme } from '@material-ui/core/styles'
import { red, green, grey } from '@material-ui/core/colors/index'
import { CentricTheme } from '@api';

const iconSize         = 24
// TODO - Need to use it in a better way
const fontWeightMedium = 500

const palette = {
  primary:           {
    main:  '#424242',
    light: '#6D6D6D',
    dark:  '#1B1B1B'
  },
  secondary:         {
    main:  '#4183F3',
    light: '#7FB3FF',
    dark:  '#0058C0'
  },
  background:        {
    modal:   '#FAFAFA',
    default: '#FFFFFF'
  },
  error:             red,
  contrastThreshold: 3,
  tonalOffset:       0.03
}

const typography  = {
  fontFamily:    'VIP',
  textTransform: 'capitalize',
  h2:      {
    fontSize:      34,
    letterSpacing: 0.3,
    lineHeight:    1.18,
    fontFamily:    'VIP'
  },
  h3:      {
    fontFamily:    'VIP',
    fontSize:      24,
    letterSpacing: 'normal',
    lineHeight:    1.17
  },
  h4:      {
    fontFamily:    'VIP',
    fontSize:      20,
    letterSpacing: 0.2,
    lineHeight:    1.2,
    fontWeight:    fontWeightMedium
  },
  h5:      {
    fontFamily:    'VIP',
    fontSize:      16,
    letterSpacing: 0.1,
    lineHeight:    1.5
  },
  // TODO - Can remove this
  h6:         {
    fontFamily:    'VIP',
    fontSize:      16,
    letterSpacing: 0.1,
    lineHeight:    1.5
  },
  body2:         {
    fontFamily:    'VIP',
    fontSize:      14,
    letterSpacing: 0.3,
    lineHeight:    1.43,
    fontWeight:    400
  },
  body1:         {
    fontFamily:    'VIP',
    fontSize:      12,
    letterSpacing: 0.2,
    lineHeight:    1.67,
    fontWeight:    400
  },
  caption:       {
    fontFamily:    'VIP',
    fontSize:      10,
    letterSpacing: 1.5,
    lineHeight:    1.6,
    textTransform: 'uppercase',
    fontWeight:    fontWeightMedium
  },
  button:        {
    fontFamily:    'VIP',
    fontSize:      14,
    letterSpacing: 0.5,
    fontWeight:    fontWeightMedium
  },
  useNextVariants: true
}
const styles: any = {
  components: {
    button:          {
      height:       36,
      borderRadius: 2
    },
    secondaryButton: {
      '&:hover': {
        backgroundColor: 'var(--secondary-button-hover-background)'
      }
    },
    tertiaryButton:  {
      '&:hover': {
        backgroundColor: 'var(--tertiary-button-hover-background)'
      }
    },
    icon:            {
      width:  iconSize,
      height: iconSize
    }
  },
  layout:     {},
  widgets:    {}
}

const colors: CentricColors = {
  primary:      'var(--primary)',
  primaryDark:  'var(--primary-dark)',
  primaryLight: 'var(--primary-light)',
  border:       'var(--border-color)',
  white:        'var(--white)',
  action:       '#FFFFFF',
  success:      green[700],
  error:        red[700],
  grey1:        grey[50],
  grey2:        'var(--background-grey-2)',
  grey3:        'var(--background-grey-3)',
  grey4:        'var(--background-grey-4)',
  grey5:        'var(--background-grey-5)',
  grey6:        'var(--background-grey-6)',
  red:          'var(--tertiary-red)',
  orange:       'var(--tertiary-orange)',
  pink:         'var(--tertiary-pink)',
  purple:       'var(--tertiary-purple)',
  yellow:       'var(--tertiary-yellow)',
  green:        'var(--tertiary-green)',

  body1: 'var(--typography-body1-color)',
  body2: 'var(--typography-body2-color)',
  display: 'var(--display-color)',
  caption: 'var(--typography-caption-color)',
  selected: 'var(--selected-background)'
}

export const cssVariables : CentricCssVars = {
  titleBarHeight:    `var(--title-bar-height)`,
  leftSidebarWidth:  `var(--left-sidebar-width)`,
  rightSidebarWidth: `var(--right-sidebar-width)`,
  cardSpacing:       `var(--card-spacing)`,
  cardPaddingSmall:  `var(--card-padding-small)`,
  lightboxZIndex:    `var(--lightbox-z-index)`
}


export const theme = createTheme({
  props: {
    MuiInputLabel: {
      shrink: true
    }
  },
  palette,
  typography,
  styles,
  colors,
  cssVars: cssVariables
} as any) as CentricTheme



// WEBPACK FOOTER //
// ./src/shared/components/ui/themes/main/index.ts